import React,{useState}from'react';
import PersonHeader from './PersonHeader';
import SummaryCards from './SummaryCards';
import ImpactTable from './ImpactTable';
import RankStaffingCalendar from './RankStaffingCalendar';

async function loadJson(url){
  const r=await fetch(url,{cache:'no-store'});
  const j=await r.json();
  if(!r.ok||j.error)throw new Error(j.error||'Unable to load data.');
  return j;
}

export default function AvailabilityPerson({person}){
  const[open,setOpen]=useState(false),[data,setData]=useState(null),[general,setGeneral]=useState(null),[loading,setLoading]=useState(false),[error,setError]=useState(''),[generalError,setGeneralError]=useState('');
  const toggle=async()=>{
    if(open){setOpen(false);return;}
    setOpen(true);if(data)return;setLoading(true);setError('');setGeneralError('');

    const[detailResult,generalResult]=await Promise.allSettled([
      loadJson(`/api/line-medic?name=${encodeURIComponent(person.name)}`),
      loadJson('/api/review')
    ]);

    if(detailResult.status==='fulfilled'){
      setData(detailResult.value);
    }else{
      setError(detailResult.reason?.message||String(detailResult.reason));
    }

    if(generalResult.status==='fulfilled'&&generalResult.value?.general){
      setGeneral(generalResult.value.general);
    }else{
      setGeneralError('General 7-day staffing is unavailable right now.');
    }

    setLoading(false);
  };
  const button=<button className="pub-btn" onClick={toggle}>{open?'Hide Staffing Impact':'7-Day Staffing Impact'}</button>;
  return <div className="pub-person"><PersonHeader person={person} button={button}/>{open&&<div className="pub-panel"><div className="pub-note">Day 1 considers Full-Day and Partial Picklists separately. Days 2–7 use Full-Day candidates only.</div>{loading&&<div className="pub-note">Loading staffing impact…</div>}{error&&<div className="pub-error">{error}</div>}{data&&<><div className="pub-note"><strong>Last Roster Upload:</strong> {data.lastRosterUpload||'Unknown'}</div><SummaryCards summary={data.summary}/><div className="pub-decision">{data.summaryResult}</div><ImpactTable rows={data.rows}/>{general&&<RankStaffingCalendar general={general} rank={data.rank||person.rank}/>} {generalError&&<div className="pub-note">{generalError}</div>}</>}</div>}</div>;
}
